export default "__VITE_ASSET__D_rz4QuT__"